import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { restServices } from 'src/app/rest.service';
import { PricingInputDTO } from '../../models/entities/pricing-input-dto';
import { SessionePricingDerivatiCambi } from '../../models/entities/sessione-pricing-derivati-cambi';
import { PricingOutputDTO } from '../../models/entities/pricing-output-dto';

declare var $: any;

export type EntityResponseType = HttpResponse<any>;

@Injectable()
export class PricingService {

    resourceUrl = environment.api_rischiocambio_url;

    constructor(private http: HttpClient) { }

    public pricingDerivatiCambi(operazioni: PricingInputDTO[]): Observable<any> {
        return this.http.post<any>(`${this.resourceUrl}${restServices.pricingDerivatiCambi}`, operazioni, { observe: 'response' });
    }

    public calcoloTassiDeposito(operazione: PricingInputDTO): Observable<any> {
        return this.http.post<any>(`${this.resourceUrl}${restServices.pricing}/${restServices.calcoloTassiDeposito}`, operazione, { observe: 'response' });
    }

    public calcolaVolatilita(input: PricingInputDTO): Observable<any> {
        return this.http.post<any>(`${this.resourceUrl}${restServices.pricing}/${restServices.calcolaVolatilita}`, input, { observe: 'response' });
    }

    public getSessioniPricingDerivatiCambi(): Observable<HttpResponse<SessionePricingDerivatiCambi[]>> {
        return this.http.get<SessionePricingDerivatiCambi[]>(`${this.resourceUrl}${restServices.getSessioniPricingDerivatiCambi}`, { observe: 'response' });
    }

    public exportPricingOutputExcel(outputList: PricingOutputDTO[]): Observable<any> {
        return this.http.post(`${this.resourceUrl}${restServices.exportPricingOutputExcel}`, outputList, { observe: 'response', responseType: 'arraybuffer' });
    }

    public eliminaSessione(id: number): Observable<any> {
        return this.http.post<any>(`${this.resourceUrl}${restServices.pricing}/${restServices.eliminaSessione}`, id, { observe: 'response' });
    }

    public uploadExcelPricingDerivatiCambi(file: any): Observable<any> {
        return this.http.post<any>(`${this.resourceUrl}${restServices.uploadExcelPricingDerivatiCambi}`, file, { observe: 'response' });
    }

    public calcoloSpotFv(input: PricingInputDTO): Observable<any> {
        return this.http.post<any>(`${this.resourceUrl}${restServices.pricing}/${restServices.calcolaSpotFv}`, input, { observe: 'response' });
    }

    public salvaSessionePricingDerivatiCambi(input: SessionePricingDerivatiCambi): Observable<any> {
        return this.http.post<any>(`${this.resourceUrl}${restServices.salvaSessionePricingDerivatiCambi}`, input, { observe: 'response' });
    }

}
